import { render, staticRenderFns } from "./ButtonsTop.vue?vue&type=template&id=095a9a3a&"
import script from "./ButtonsTop.vue?vue&type=script&lang=js&"
export * from "./ButtonsTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports